<template>
  <div>
    <v-btn icon small @click.stop="dialog = true"
      v-if="this.iconError">
      <v-icon :color="ui.colorError"> {{icon}} </v-icon>
    </v-btn>
    <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogSmall">
      <v-card :class="ui.bkgdColor">
        <v-card-title :class="ui.textTitle">
          Licence
        </v-card-title>
        <v-card-text>
          <v-layout row :class="ui.textDescription">
            <v-flex xs4>
              <v-icon large :color="ui.colorWarning"> {{icon}} </v-icon>
            </v-flex>
            <v-flex xs8>
              {{error}}
            </v-flex>
          </v-layout>
          <v-layout row class="mt-4"/>
          <v-layout row :class="ui.textDescription">
            <v-flex xs4>
              <v-icon large :color="ui.colorError"> {{icon}} </v-icon>
            </v-flex>
            <v-flex xs8>
              {{warning}}
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn :color="ui.btnColor" flat @click="dialog = false">
            <v-icon left> exit_to_app </v-icon>
            back
          </v-btn>
          <v-spacer/>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import apptheme from "@/frame/theme/mixins/apptheme.js";
import licenceFunctions from "@/admin/functions/mixins/licenceFunctions.js";
// eslint-disable-next-line
export default {
  data() {
    return {
      dialog: false,
      icon: "dashboard_customize",
      // eslint-disable-next-line
      error: "Licence limits are almost used, please limited app usage in short term or consider subscribing to differ licence which could be more suitable to business requirements.",
      // eslint-disable-next-line
      warning: "Current licence or subscription has expired or was exceed. Please review current business requirements and contact app administrator or upgrade to higher subscription model. User account was locked."
    };
  },
  mixins: [apptheme, licenceFunctions],
  computed: {
    iconError() {
      let logic = this.licenceOK;
      return !logic;
    }
  }
};
</script>
